import { useState } from "react";
import {
  createUserWithEmailAndPassword,
  GoogleAuthProvider,
  signInWithPopup,
} from "firebase/auth";
import { auth } from "../../firebase/firebase";
import { useNavigate } from "react-router-dom";
import Header from "../../components/Header/Header";
import "./signup.css";

function Signup() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleEmailSignup = async () => {
    setError("");
    try {
      await createUserWithEmailAndPassword(auth, email, password);
      navigate("/select-persona", { replace: true });
    } catch (err) {
      setError(err.message);
    }
  };

  const handleGoogleSignup = async () => {
    setError("");
    try {
      const provider = new GoogleAuthProvider();
      await signInWithPopup(auth, provider);
      navigate("/select-persona", { replace: true });
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <>
      <Header />

      <div className="signup-container">
        <div className="signup-card">
          <h1>Create your account</h1>

          <p className="signup-subtext">
            Get started on Prufyy in just a few steps.
          </p>

          {error && <div className="signup-error">{error}</div>}

          <input
            className="signup-input"
            type="email"
            placeholder="Email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <input
            className="signup-input"
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          <button
            className="btn-primary signup-button"
            onClick={handleEmailSignup}
          >
            Sign up with Email
          </button>

          <div className="signup-divider">or</div>

          <button
            className="btn-secondary signup-button"
            onClick={handleGoogleSignup}
          >
            Continue with Google
          </button>
        </div>
      </div>
    </>
  );
}

export default Signup;
